import React, {
  useCallback, useState, Fragment, ReactElement,
} from 'react';
import FieldText from '../field-text/field-text.component';
import SearchIcon from '../../icons/search-icon';
import useStylesSearchDropdown from './search-dropdown.styles';

const SearchDropdown: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const SEARCH_FIELD_TEXT_DEFAULT: string = 'Search...';
  const SEARCH_QUERY_MIN_LENGTH: number = 3;

  const {
    searchOptions,
    optionsTotal,
    onSearch,
  } = props;

  const { classes } = useStylesSearchDropdown();

  const [searchQueryValue, setSearchQueryValue]: [string | null, Function] = useState(null);

  const onChange: Function = useCallback((searchQuery?: string): void => {
    const searchQueryFiltered: string | null = searchQuery ? searchQuery.trim() : null;

    if (onSearch && ((searchQueryFiltered && searchQueryFiltered.length >= SEARCH_QUERY_MIN_LENGTH)
      || !searchQueryFiltered)) {
      onSearch(searchQueryFiltered || null, searchOptions || {});
    }
  }, [searchOptions]);

  return (
    <Fragment>
      <FieldText
        isPlain
        isFullWidth
        withUnderline
        withAutoFocus
        className={classes.fieldTextSearch}
        value={searchQueryValue || ''}
        icon={<SearchIcon className={classes.searchDropdownIcon} />}
        placeholder={SEARCH_FIELD_TEXT_DEFAULT}
        onChange={(event: React.ChangeEvent, value: string): void => {
          onChange(value);
          setSearchQueryValue(value);
        }}
        onKeyDown={(event: React.KeyboardEvent): void => {
          event.stopPropagation();
        }}
      />
      {
        !!searchQueryValue && (optionsTotal !== undefined && !optionsTotal) && (
          <div className={classes.containerNoResults}>
            No search results
          </div>
        )
      }
    </Fragment>
  );
});

export default SearchDropdown;
